import React from 'react'

const SvgComponent = props => (
  <svg width={18} height={22} viewBox="0 0 18 22" {...props}>
    <g fill="currentColor" fillRule="evenodd">
      <path d="M9.5 0L7.75 2 6 4h7l-1.75-2zM9.5 18H6l1.75 2 1.75 2 1.75-2L13 18zM18 15.278c0 .28-.172.506-.384.506H.384c-.212 0-.384-.227-.384-.506v-.772c0-.28.172-.506.384-.506h17.232c.212 0 .384.226.384.506v.772zM18 11.278c0 .28-.172.506-.384.506H.384c-.212 0-.384-.227-.384-.506v-.772c0-.28.172-.506.384-.506h17.232c.212 0 .384.226.384.506v.772zM18 7.278c0 .28-.172.506-.384.506H.384C.172 7.784 0 7.557 0 7.278v-.772C0 6.226.172 6 .384 6h17.232c.212 0 .384.226.384.506v.772z" />
    </g>
  </svg>
)

export default SvgComponent
